import accounting from 'accounting';
// import { fenToYuan } from '@/common/number/';

export default {};

export const tooltipStyle = {
  trigger: 'item',
  formatter(item) {
    const isMoney = item.seriesName.indexOf('元') !== -1;
    const value = isMoney
      ? accounting.formatMoney(item.value, '￥')
      : accounting.formatNumber(item.value);
    return `${item.seriesName}<br>${item.name}:${value}`;
  },
};

export const legendStyle = {
  type: 'scroll',
  orient: 'vertical',
  right: 10,
  top: 20,
  bottom: 20,
  data: [],
};

export const seriesStyle = {
  type: 'pie',
  radius: ['50%', '70%'],
  center: ['40%', '50%'],
  avoidLabelOverlap: false,
  labelLine: {
    normal: {
      show: false,
    },
  },
};
